<template lang="pug">
.navbar.navbar-light: .container
    router-link.navbar-brand(to="/")
        img(src="@/assets/logo.svg", height="40")
        .app-title
            | Luft
            br
            | Verbund
            br
            | Rechner

    .media.small.text-right.text-nowrap(v-if="loggedIn")
        .media-body.d-none.d-sm-block
            strong {{ userName }}
            br
            .text-muted {{ accountName }}
        .logout(@click="logout")
            font-awesome-icon(icon="power-off", size="3x")
</template>

<script>
import { mapGetters } from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPowerOff, faUserCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPowerOff, faUserCircle)

export default {
    computed: {
        ...mapGetters([
            'loggedIn',
            'userName',
            'accountName'
        ])
    },
    methods: {
        logout () {
            this.$store.dispatch('authentication/logout')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.navbar {
    background-color: #fff;
    border-bottom: 1px solid #cccccc;
    min-height: 60px;
    padding: 10px;

    .navbar-brand {
        display: flex;
        font-family: $headings-font-family;
        font-weight: 500;
        font-size: 1.4rem;
        line-height: 1.8;
        height: 40px;
        padding: 0;

        img {
            max-height: 100%;
            margin-right: 0.5rem;
        }

        .app-title {
            line-height: 1;
            font-size: 65%;
            text-transform: uppercase;
        }
    }

    .logout {
        margin-left: 1.5rem;
        color: $secondary;
        cursor: pointer;

        &:hover {
            color: $primary;
        }
    }
}
</style>
